import axios from "axios";
import _ from "lodash";
import { GET_SUGGESTIONS, CLEAR_SUGGESTIONS } from "./types";

const developmentConfig = require("../../app_configuration").CONFIGURATION.development; // todo add suggestions endpoint to all envs

const cleanHighlightField = highlightObj => {
  const cleanHighlight = {};

  _.forOwn(highlightObj, (value, key) => {
    const newKey = key.replace(/\.edgeTok$/g, "");
    cleanHighlight[newKey] = _.head(value);
  });

  return cleanHighlight;
};

const cleanSuggestionsResponse = (response, getSuggestionType) => {
  let suggestions = _.get(response, "hits.hits", []).map(e => {
    return {
      ...e._source,
      highlight: cleanHighlightField(e.highlight)
    };
  });

  const attributesToReturn = ["name", "highlight"];
  if (getSuggestionType) {
    attributesToReturn.push("type");
  }

  return suggestions
    .filter(suggestion => suggestion && suggestion.name)
    .map(suggestion => _.pick(suggestion, attributesToReturn));
};

export const getSuggestions = (string, endpointPrefix) => async (dispatch, getState) => {
  const action = {
    type: GET_SUGGESTIONS,
    payload: {}
  };

  try {
    const response = await axios.get(`${developmentConfig.AWS_API_URL}${endpointPrefix}${string}`);
    action.payload.status = response.status;
    action.payload.results = cleanSuggestionsResponse(response.data, true);
  } catch (err) {
    action.payload.status = 500;
    action.payload.results = [];
  }

  dispatch(action);
};

export const clearSuggestions = () => {
  return {
    type: CLEAR_SUGGESTIONS
  };
};
